export default __webpack_public_path__ + "static/media/pencil-icon.d7f796e4.svg";